export default "__VITE_ASSET__Cs9MZm5E__"